import HappyLikeStarIcon from '@stencil/icons/src/HappyLikeStarIcon/HappyLikeStarIcon';
import * as S from './AltAccoStars.styles';

interface GoStayTagPersuasionType {
  hotelRating?: number;
  margin?: string;
  isMweb?: boolean;
  isMwebSrp?: boolean;
  isCarousel?: boolean;
}

export const AltAccoStars = ({
  hotelRating = 5,
  margin = '',
  isMweb = false,
  isMwebSrp = false,
  isCarousel = false,
}: GoStayTagPersuasionType) => {
  return (
    <S.LikeAStarTagContainer
      margin={margin}
      isMweb={isMweb}
      isMwebSrp={isMwebSrp}
      isCarousel={isCarousel}
    >
      <HappyLikeStarIcon
        margin={`0 ${isMweb || isCarousel ? '0.5rem' : '1rem'} 0 0`}
        width={isMweb && '1rem'}
        height={isMweb && '1rem'}
      />
      Like a {hotelRating} Star
    </S.LikeAStarTagContainer>
  );
};
